import { apiURLNew, callAPI } from 'api/main';

interface IParams {
  document: string;
  lang: string;
}

export default async ({ document, lang }: IParams): Promise<any> => {
  try {
    const res = await callAPI({
      url: `${apiURLNew}/auth/v1/send-token/document/${document}`,
      method: 'POST',
      isLegacy: false,
      params: {
        lang,
      },
    });

    const data = res.request;

    if (data) {
      return data;
    }

    null;
  } catch (ex) {
    return null;
  }
};
